module.exports = __webpack_public_path__ + "img/obogrevatel_elektricheskiy.195a4d4f.svg";